import { zodTransformFirestoreTimestampToDate } from "../utils/zodUtils.mjs";
import { zodFlavorId } from "./ids.mjs";
import { SubscriptionStatus } from "./subscription.mjs";
import { z as z$1 } from "zod";

// src/models/subscriptionStatusChangeLog.ts
/**
* UTC year key used as Firestore document id: `YYYY` (e.g. `2026`).
*/
function yearDocIdFromDate(d) {
	return String(d.getUTCFullYear());
}
const subscriptionStatusValueSchema = z$1.enum(Object.values(SubscriptionStatus));
const subscriptionStatusChangeLogEventSchema = z$1.object({
	eventId: z$1.string(),
	timestamp: z$1.any().transform(zodTransformFirestoreTimestampToDate).pipe(z$1.date()),
	previousStatus: subscriptionStatusValueSchema.nullable(),
	nextStatus: subscriptionStatusValueSchema.nullable(),
	stripeCustomerId: zodFlavorId()
});
const subscriptionStatusChangeLogYearDocSchema = z$1.object({
	id: zodFlavorId(),
	customerId: zodFlavorId(),
	yearDocId: zodFlavorId().optional(),
	events: z$1.array(subscriptionStatusChangeLogEventSchema)
}).refine((d) => d.yearDocId === void 0 || d.yearDocId === d.id, {
	message: "yearDocId must match document id when present",
	path: ["yearDocId"]
});

export { subscriptionStatusChangeLogEventSchema, subscriptionStatusChangeLogYearDocSchema, yearDocIdFromDate };
//# sourceMappingURL=subscriptionStatusChangeLog.mjs.map